module.exports = __webpack_public_path__ + "static/img/04.1df28ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/12/04.png
// module id = 5/Bf
// module chunks = 2